<template>
    <v-dialog v-model="dialog" max-width="705" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11" :loading="note">
            <v-row justify="end" class="ma-0">
                <v-btn icon>
                    <v-icon @click="dialog = false">mdi-close</v-icon>
                </v-btn>
            </v-row>
            <h2 class="text-center">{{$t('homework.note')}}</h2>
            <p class="font-weight-bold mt-10">{{note}}</p>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['note'],
        data(){
            return {
                dialog: false,
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "../../scss/components/show";
</style>